module.exports = __webpack_public_path__ + "img/image4@3x.dcef4896.png";